import React from "react";
import { Button, Intent, Alert } from "@blueprintjs/core";
import { Icon } from "../../../../atoms/Icon";
import { useRemoveShippingProfile } from "./hooks";
import styles from "../ShippingSettings.module.scss";

export function DeleteShippingProfileButton({ profileId }) {
  const {
    setIsAlertOpen,
    isAlertOpen,
    onRemoveConfirmed
  } = useRemoveShippingProfile(profileId);

  return (
    <>
      <Button
        text="Remove Profile"
        intent={Intent.DANGER}
        className={styles.removeButton}
        minimal={true}
        className={styles.removeButton}
        onClick={() => setIsAlertOpen(true)}
      />
      <Alert
        cancelButtonText="Cancel"
        confirmButtonText="Yes, remove it"
        icon={<Icon name="warning-sign" color="#7a869b" size={32} />}
        intent="danger"
        isOpen={isAlertOpen}
        onCancel={() => setIsAlertOpen(false)}
        onConfirm={onRemoveConfirmed}
        canEscapeKeyCancel
        canOutsideClickCancel
      >
        <p>Are you sure you want to remove this profile?</p>
      </Alert>
    </>
  );
}
